export default __webpack_public_path__ + "static/productconfigold-d626967b72d94667b34295a7d1bc40a0.jpg";